import { render, staticRenderFns } from "./userStatus.vue?vue&type=template&id=54c13cd2&"
import script from "./userStatus.vue?vue&type=script&lang=js&"
export * from "./userStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports